import * as React from "react";
import { connect } from "react-redux";
import { Col } from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import CaseCard from "./components/CaseCard";
import { IReduxState } from "../../../reduxTypes";
import { CardLoader } from "src/share/components/ChartLoader/CardLoader";
import { ICasesViewProps } from "./caseView.type";
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import { CaseSidebar } from "src/modules/Case/CaseSidebar/CaseSidebar";
import { useCases } from "./hooks/useCases";
import { useQueryOptions } from "./hooks/useQueryOptions";
import { useHistory, useLocation } from "react-router";
import useRouteState from "src/share/hooks/useRouteState";
import { useCasesViewType } from "./hooks/useCasesViewType";
import CasesFilters from "./components/CasesFilters";
import "./casesView.css";

const CasesView: React.FC<ICasesViewProps> = props => {
  const history = useHistory();
  const location = useLocation();
  const casesViewRef = React.useRef<HTMLDivElement | null>(null);
  const { routeState, setRouteState } = useRouteState();
  const { casesViewType } = useCasesViewType(props);
  const {
    actions,
    dateRange,
    options,
    searchText,
    isFilteringOptions,
    showDatePicker
  } = useQueryOptions(casesViewType);
  const { cases, isLoading } = useCases(options);
  const isInitialLoading = isLoading && !cases.results.length;

  const handleCaseRedirect = (childId: string, caseId: string) => {
    const scrollPosition =
      casesViewRef && casesViewRef.current && casesViewRef.current.scrollTop;
    const redirectedPath = `/case/children/${caseId}`;
    if (isFilteringOptions) {
      setRouteState({
        state: cases,
        options,
        key: childId + caseId,
        scrollPosition,
        storedPath: location.pathname,
        redirectedPath
      });
    }
    history.push(redirectedPath);
  };

  const loader = (length: number) => {
    return Array.apply(null, { length }).map((data, index) => (
      <Col
        key={index}
        xl="4"
        lg="6"
        md="12"
        sm="12"
        xs="12"
        className="card-column"
      >
        <CardLoader />
      </Col>
    ));
  };

  const handleScrollPosition = (childId: string, caseId: string) => {
    if (
      routeState &&
      routeState.scrollPosition &&
      routeState.key &&
      routeState.key === childId + caseId &&
      casesViewRef.current
    ) {
      casesViewRef.current.scrollTop = routeState.scrollPosition;
    }
  };

  return (
    <div className="cases-view-container">
      <CasesFilters
        casesTotal={cases.total}
        casesViewType={casesViewType}
        dateRange={dateRange}
        showClearFilters={isFilteringOptions}
        onClearFilters={actions.handleClearFilters}
        onDateChange={actions.handleDateChange}
        onDateFocus={actions.handleDateFocus}
        onDatePickerToogle={actions.handleDatePickerToogle}
        onSearchText={actions.handleSearchText}
        onSortChange={actions.handleSortChange}
        options={options}
        searchText={searchText}
        showDatePicker={showDatePicker}
      />
      <div
        className={`case-view ${isFilteringOptions && "case-view-filtering"}`}
        id="case-view"
        ref={casesViewRef}
      >
        <InfiniteScroll
          next={actions.handleLoadMore}
          dataLength={cases.results.length}
          loader={loader(24)}
          hasMore={cases.results.length !== cases.total || isInitialLoading}
          className="cases-view-infinite-scroll"
          scrollableTarget="case-view"
        >
          {cases.results.map(caseData => (
            <CaseCard
              key={caseData.childId + caseData.caseId}
              caseInfo={caseData}
              onCaseRedirect={handleCaseRedirect}
              onScrollPosition={handleScrollPosition}
            />
          ))}
          {isLoading && loader(24)}
          {!isLoading && cases.results.length === 0 && (
            <h4 className="no-results">No data found</h4>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(CaseSidebar)(
  connect(mapStateToProps, null)(CasesView)
);
